import * as z from 'zod';
import { CitySchema } from '../citySchema';

export const parseCityList = (value: unknown) => {
    return z.array(CitySchema).parse(value);
};
